import * as X from "react";
import Br, { forwardRef as ur, useContext as qr, createContext as $t } from "react";
import { Trigger as kt } from "@illa-design/trigger";
import { useMergeValue as It } from "@illa-design/system";
import { css as ge } from "@emotion/react";
import { globalColor as Gr, illaPrefix as Hr, getColor as ie, applyBoxStyle as Dt, deleteCssProps as Jr } from "@illa-design/theme";
var nr = { exports: {} }, ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Mt() {
  if (Nr)
    return ye;
  Nr = 1;
  var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, d, h) {
    var p, y = {}, C = null, S = null;
    h !== void 0 && (C = "" + h), d.key !== void 0 && (C = "" + d.key), d.ref !== void 0 && (S = d.ref);
    for (p in d)
      a.call(d, p) && !i.hasOwnProperty(p) && (y[p] = d[p]);
    if (l && l.defaultProps)
      for (p in d = l.defaultProps, d)
        y[p] === void 0 && (y[p] = d[p]);
    return { $$typeof: r, type: l, key: C, ref: S, props: y, _owner: o.current };
  }
  return ye.Fragment = n, ye.jsx = f, ye.jsxs = f, ye;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Ft() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), R = Symbol.iterator, b = "@@iterator";
    function I(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = R && t[R] || t[b];
      return typeof s == "function" ? s : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        $("error", t, u);
      }
    }
    function $(t, s, u) {
      {
        var m = _.ReactDebugCurrentFrame, x = m.getStackAddendum();
        x !== "" && (s += "%s", u = u.concat([x]));
        var k = u.map(function(w) {
          return String(w);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, k);
      }
    }
    var D = !1, c = !1, j = !1, A = !1, Be = !1, Re;
    Re = Symbol.for("react.module.reference");
    function qe(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Be || t === o || t === h || t === p || A || t === S || D || c || j || typeof t == "object" && t !== null && (t.$$typeof === C || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Re || t.getModuleId !== void 0));
    }
    function Ge(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var x = s.displayName || s.name || "";
      return x !== "" ? u + "(" + x + ")" : u;
    }
    function xe(t) {
      return t.displayName || "Context";
    }
    function q(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return xe(s) + ".Consumer";
          case f:
            var u = t;
            return xe(u._context) + ".Provider";
          case d:
            return Ge(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : q(t.type) || "Memo";
          case C: {
            var x = t, k = x._payload, w = x._init;
            try {
              return q(w(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, Q = 0, Te, Oe, fe, Pe, le, Ne, Ae;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function He() {
      {
        if (Q === 0) {
          Te = console.log, Oe = console.info, fe = console.warn, Pe = console.error, le = console.group, Ne = console.groupCollapsed, Ae = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Q++;
      }
    }
    function Je() {
      {
        if (Q--, Q === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: Te
            }),
            info: K({}, t, {
              value: Oe
            }),
            warn: K({}, t, {
              value: fe
            }),
            error: K({}, t, {
              value: Pe
            }),
            group: K({}, t, {
              value: le
            }),
            groupCollapsed: K({}, t, {
              value: Ne
            }),
            groupEnd: K({}, t, {
              value: Ae
            })
          });
        }
        Q < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = _.ReactCurrentDispatcher, pe;
    function re(t, s, u) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (x) {
            var m = x.stack.trim().match(/\n( *(at )?)/);
            pe = m && m[1] || "";
          }
        return `
` + pe + t;
      }
    }
    var ve = !1, te;
    {
      var Ke = typeof WeakMap == "function" ? WeakMap : Map;
      te = new Ke();
    }
    function v(t, s) {
      if (!t || ve)
        return "";
      {
        var u = te.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      ve = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = de.current, de.current = null, He();
      try {
        if (s) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (Z) {
              m = Z;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (Z) {
              m = Z;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            m = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && m && typeof Z.stack == "string") {
          for (var g = Z.stack.split(`
`), W = m.stack.split(`
`), M = g.length - 1, F = W.length - 1; M >= 1 && F >= 0 && g[M] !== W[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (g[M] !== W[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || g[M] !== W[F]) {
                    var B = `
` + g[M].replace(" at new ", " at ");
                    return t.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", t.displayName)), typeof t == "function" && te.set(t, B), B;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ve = !1, de.current = k, Je(), Error.prepareStackTrace = x;
      }
      var oe = t ? t.displayName || t.name : "", Pr = oe ? re(oe) : "";
      return typeof t == "function" && te.set(t, Pr), Pr;
    }
    function he(t, s, u) {
      return v(t, !1);
    }
    function ne(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ne(t));
      if (typeof t == "string")
        return re(t);
      switch (t) {
        case h:
          return re("Suspense");
        case p:
          return re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return he(t.render);
          case y:
            return ee(t.type, s, u);
          case C: {
            var m = t, x = m._payload, k = m._init;
            try {
              return ee(k(x), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, yr = {}, Er = _.ReactDebugCurrentFrame;
    function Ie(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        Er.setExtraStackFrame(u);
      } else
        Er.setExtraStackFrame(null);
    }
    function dt(t, s, u, m, x) {
      {
        var k = Function.call.bind(ke);
        for (var w in t)
          if (k(t, w)) {
            var g = void 0;
            try {
              if (typeof t[w] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              g = t[w](s, w, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              g = M;
            }
            g && !(g instanceof Error) && (Ie(x), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, w, typeof g), Ie(null)), g instanceof Error && !(g.message in yr) && (yr[g.message] = !0, Ie(x), E("Failed %s type: %s", u, g.message), Ie(null));
          }
      }
    }
    var pt = Array.isArray;
    function Ze(t) {
      return pt(t);
    }
    function vt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function ht(t) {
      try {
        return br(t), !1;
      } catch {
        return !0;
      }
    }
    function br(t) {
      return "" + t;
    }
    function gr(t) {
      if (ht(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vt(t)), br(t);
    }
    var me = _.ReactCurrentOwner, mt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _r, Sr, Xe;
    Xe = {};
    function yt(t) {
      if (ke.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Et(t) {
      if (ke.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function bt(t, s) {
      if (typeof t.ref == "string" && me.current && s && me.current.stateNode !== s) {
        var u = q(me.current.type);
        Xe[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(me.current.type), t.ref), Xe[u] = !0);
      }
    }
    function gt(t, s) {
      {
        var u = function() {
          _r || (_r = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function _t(t, s) {
      {
        var u = function() {
          Sr || (Sr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var St = function(t, s, u, m, x, k, w) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: w,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function wt(t, s, u, m, x) {
      {
        var k, w = {}, g = null, W = null;
        u !== void 0 && (gr(u), g = "" + u), Et(s) && (gr(s.key), g = "" + s.key), yt(s) && (W = s.ref, bt(s, x));
        for (k in s)
          ke.call(s, k) && !mt.hasOwnProperty(k) && (w[k] = s[k]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (k in M)
            w[k] === void 0 && (w[k] = M[k]);
        }
        if (g || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          g && gt(w, F), W && _t(w, F);
        }
        return St(t, g, W, x, m, me.current, w);
      }
    }
    var Qe = _.ReactCurrentOwner, wr = _.ReactDebugCurrentFrame;
    function ae(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        wr.setExtraStackFrame(u);
      } else
        wr.setExtraStackFrame(null);
    }
    var er;
    er = !1;
    function rr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Cr() {
      {
        if (Qe.current) {
          var t = q(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Ct(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Rr = {};
    function Rt(t) {
      {
        var s = Cr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function xr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Rt(s);
        if (Rr[u])
          return;
        Rr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== Qe.current && (m = " It was passed a child from " + q(t._owner.type) + "."), ae(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ae(null);
      }
    }
    function Tr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (Ze(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            rr(m) && xr(m, s);
          }
        else if (rr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var x = I(t);
          if (typeof x == "function" && x !== t.entries)
            for (var k = x.call(t), w; !(w = k.next()).done; )
              rr(w.value) && xr(w.value, s);
        }
      }
    }
    function xt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = q(s);
          dt(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !er) {
          er = !0;
          var x = q(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Tt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            ae(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ae(null);
            break;
          }
        }
        t.ref !== null && (ae(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Or(t, s, u, m, x, k) {
      {
        var w = qe(t);
        if (!w) {
          var g = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Ct(x);
          W ? g += W : g += Cr();
          var M;
          t === null ? M = "null" : Ze(t) ? M = "array" : t !== void 0 && t.$$typeof === r ? (M = "<" + (q(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, g);
        }
        var F = wt(t, s, u, x, k);
        if (F == null)
          return F;
        if (w) {
          var B = s.children;
          if (B !== void 0)
            if (m)
              if (Ze(B)) {
                for (var oe = 0; oe < B.length; oe++)
                  Tr(B[oe], t);
                Object.freeze && Object.freeze(B);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Tr(B, t);
        }
        return t === a ? Tt(F) : xt(F), F;
      }
    }
    function Ot(t, s, u) {
      return Or(t, s, u, !0);
    }
    function Pt(t, s, u) {
      return Or(t, s, u, !1);
    }
    var Nt = Pt, At = Ot;
    Ee.Fragment = a, Ee.jsx = Nt, Ee.jsxs = At;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? nr.exports = Mt() : nr.exports = Ft();
var $r = nr.exports;
function Vt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function jt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Lt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(jt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = Vt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", je = "-moz-", T = "-webkit-", fr = "comm", lr = "rule", dr = "decl", Yt = "@import", Kr = "@keyframes", Wt = "@layer", zt = Math.abs, We = String.fromCharCode, Ut = Object.assign;
function Bt(e, r) {
  return L(e, 0) ^ 45 ? (((r << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function Zr(e) {
  return e.trim();
}
function qt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function O(e, r, n) {
  return e.replace(r, n);
}
function ar(e, r) {
  return e.indexOf(r);
}
function L(e, r) {
  return e.charCodeAt(r) | 0;
}
function _e(e, r, n) {
  return e.slice(r, n);
}
function H(e) {
  return e.length;
}
function pr(e) {
  return e.length;
}
function De(e, r) {
  return r.push(e), e;
}
function Gt(e, r) {
  return e.map(r).join("");
}
var ze = 1, ce = 1, Xr = 0, z = 0, V = 0, ue = "";
function Ue(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: ze, column: ce, length: f, return: "" };
}
function be(e, r) {
  return Ut(Ue("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Ht() {
  return V;
}
function Jt() {
  return V = z > 0 ? L(ue, --z) : 0, ce--, V === 10 && (ce = 1, ze--), V;
}
function U() {
  return V = z < Xr ? L(ue, z++) : 0, ce++, V === 10 && (ce = 1, ze++), V;
}
function J() {
  return L(ue, z);
}
function Me() {
  return z;
}
function Ce(e, r) {
  return _e(ue, e, r);
}
function Se(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Qr(e) {
  return ze = ce = 1, Xr = H(ue = e), z = 0, [];
}
function et(e) {
  return ue = "", e;
}
function Fe(e) {
  return Zr(Ce(z - 1, or(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Kt(e) {
  for (; (V = J()) && V < 33; )
    U();
  return Se(e) > 2 || Se(V) > 3 ? "" : " ";
}
function Zt(e, r) {
  for (; --r && U() && !(V < 48 || V > 102 || V > 57 && V < 65 || V > 70 && V < 97); )
    ;
  return Ce(e, Me() + (r < 6 && J() == 32 && U() == 32));
}
function or(e) {
  for (; U(); )
    switch (V) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && or(V);
        break;
      case 40:
        e === 41 && or(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function Xt(e, r) {
  for (; U() && e + V !== 47 + 10; )
    if (e + V === 42 + 42 && J() === 47)
      break;
  return "/*" + Ce(r, z - 1) + "*" + We(e === 47 ? e : U());
}
function Qt(e) {
  for (; !Se(J()); )
    U();
  return Ce(e, z);
}
function en(e) {
  return et(Ve("", null, null, null, [""], e = Qr(e), 0, [0], e));
}
function Ve(e, r, n, a, o, i, f, l, d) {
  for (var h = 0, p = 0, y = f, C = 0, S = 0, R = 0, b = 1, I = 1, _ = 1, E = 0, $ = "", D = o, c = i, j = a, A = $; I; )
    switch (R = E, E = U()) {
      case 40:
        if (R != 108 && L(A, y - 1) == 58) {
          ar(A += O(Fe(E), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += Fe(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += Kt(R);
        break;
      case 92:
        A += Zt(Me() - 1, 7);
        continue;
      case 47:
        switch (J()) {
          case 42:
          case 47:
            De(rn(Xt(U(), Me()), r, n), d);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * b:
        l[h++] = H(A) * _;
      case 125 * b:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            I = 0;
          case 59 + p:
            _ == -1 && (A = O(A, /\f/g, "")), S > 0 && H(A) - y && De(S > 32 ? Ir(A + ";", a, n, y - 1) : Ir(O(A, " ", "") + ";", a, n, y - 2), d);
            break;
          case 59:
            A += ";";
          default:
            if (De(j = kr(A, r, n, h, p, o, l, $, D = [], c = [], y), i), E === 123)
              if (p === 0)
                Ve(A, r, j, j, D, i, y, l, c);
              else
                switch (C === 99 && L(A, 3) === 110 ? 100 : C) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ve(e, j, j, a && De(kr(e, j, j, 0, 0, o, l, $, o, D = [], y), c), o, c, y, l, a ? D : c);
                    break;
                  default:
                    Ve(A, j, j, j, [""], c, 0, l, c);
                }
        }
        h = p = S = 0, b = _ = 1, $ = A = "", y = f;
        break;
      case 58:
        y = 1 + H(A), S = R;
      default:
        if (b < 1) {
          if (E == 123)
            --b;
          else if (E == 125 && b++ == 0 && Jt() == 125)
            continue;
        }
        switch (A += We(E), E * b) {
          case 38:
            _ = p > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            l[h++] = (H(A) - 1) * _, _ = 1;
            break;
          case 64:
            J() === 45 && (A += Fe(U())), C = J(), p = y = H($ = A += Qt(Me())), E++;
            break;
          case 45:
            R === 45 && H(A) == 2 && (b = 0);
        }
    }
  return i;
}
function kr(e, r, n, a, o, i, f, l, d, h, p) {
  for (var y = o - 1, C = o === 0 ? i : [""], S = pr(C), R = 0, b = 0, I = 0; R < a; ++R)
    for (var _ = 0, E = _e(e, y + 1, y = zt(b = f[R])), $ = e; _ < S; ++_)
      ($ = Zr(b > 0 ? C[_] + " " + E : O(E, /&\f/g, C[_]))) && (d[I++] = $);
  return Ue(e, r, n, o === 0 ? lr : l, d, h, p);
}
function rn(e, r, n) {
  return Ue(e, r, n, fr, We(Ht()), _e(e, 2, -2), 0);
}
function Ir(e, r, n, a) {
  return Ue(e, r, n, dr, _e(e, 0, a), _e(e, a + 1, -1), a);
}
function se(e, r) {
  for (var n = "", a = pr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function tn(e, r, n, a) {
  switch (e.type) {
    case Wt:
      if (e.children.length)
        break;
    case Yt:
    case dr:
      return e.return = e.return || e.value;
    case fr:
      return "";
    case Kr:
      return e.return = e.value + "{" + se(e.children, a) + "}";
    case lr:
      e.value = e.props.join(",");
  }
  return H(n = se(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function nn(e) {
  var r = pr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function an(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function on(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var sn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = J(), o === 38 && i === 12 && (n[a] = 1), !Se(i); )
    U();
  return Ce(r, z);
}, cn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Se(o)) {
      case 0:
        o === 38 && J() === 12 && (n[a] = 1), r[a] += sn(z - 1, n, a);
        break;
      case 2:
        r[a] += Fe(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = J() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += We(o);
    }
  while (o = U());
  return r;
}, un = function(r, n) {
  return et(cn(Qr(r), n));
}, Dr = /* @__PURE__ */ new WeakMap(), fn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Dr.get(a)) && !o) {
      Dr.set(r, !0);
      for (var i = [], f = un(n, i), l = a.props, d = 0, h = 0; d < f.length; d++)
        for (var p = 0; p < l.length; p++, h++)
          r.props[h] = i[d] ? f[d].replace(/&\f/g, l[p]) : l[p] + " " + f[d];
    }
  }
}, ln = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, dn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", pn = function(r) {
  return r.type === "comm" && r.children.indexOf(dn) > -1;
}, vn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), d = l.length - 1; d >= 0; d--) {
          var h = l[d];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (pn(h))
              return;
            break;
          }
        }
        i.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, rt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, hn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!rt(n[a]))
      return !0;
  return !1;
}, Mr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, mn = function(r, n, a) {
  rt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Mr(r)) : hn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Mr(r)));
};
function tt(e, r) {
  switch (Bt(e, r)) {
    case 5103:
      return T + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return T + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return T + e + je + e + Y + e + e;
    case 6828:
    case 4268:
      return T + e + Y + e + e;
    case 6165:
      return T + e + Y + "flex-" + e + e;
    case 5187:
      return T + e + O(e, /(\w+).+(:[^]+)/, T + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return T + e + Y + "flex-item-" + O(e, /flex-|-self/, "") + e;
    case 4675:
      return T + e + Y + "flex-line-pack" + O(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return T + e + Y + O(e, "shrink", "negative") + e;
    case 5292:
      return T + e + Y + O(e, "basis", "preferred-size") + e;
    case 6060:
      return T + "box-" + O(e, "-grow", "") + T + e + Y + O(e, "grow", "positive") + e;
    case 4554:
      return T + O(e, /([^-])(transform)/g, "$1" + T + "$2") + e;
    case 6187:
      return O(O(O(e, /(zoom-|grab)/, T + "$1"), /(image-set)/, T + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return O(e, /(image-set\([^]*)/, T + "$1$`$1");
    case 4968:
      return O(O(e, /(.+:)(flex-)?(.*)/, T + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + T + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return O(e, /(.+)-inline(.+)/, T + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (H(e) - 1 - r > 6)
        switch (L(e, r + 1)) {
          case 109:
            if (L(e, r + 4) !== 45)
              break;
          case 102:
            return O(e, /(.+:)(.+)-([^]+)/, "$1" + T + "$2-$3$1" + je + (L(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ar(e, "stretch") ? tt(O(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (L(e, r + 1) !== 115)
        break;
    case 6444:
      switch (L(e, H(e) - 3 - (~ar(e, "!important") && 10))) {
        case 107:
          return O(e, ":", ":" + T) + e;
        case 101:
          return O(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + T + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + T + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, r + 11)) {
        case 114:
          return T + e + Y + O(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return T + e + Y + O(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return T + e + Y + O(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return T + e + Y + e + e;
  }
  return e;
}
var yn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case dr:
        r.return = tt(r.value, r.length);
        break;
      case Kr:
        return se([be(r, {
          value: O(r.value, "@", "@" + T)
        })], o);
      case lr:
        if (r.length)
          return Gt(r.props, function(i) {
            switch (qt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return se([be(r, {
                  props: [O(i, /:(read-\w+)/, ":" + je + "$1")]
                })], o);
              case "::placeholder":
                return se([be(r, {
                  props: [O(i, /:(plac\w+)/, ":" + T + "input-$1")]
                }), be(r, {
                  props: [O(i, /:(plac\w+)/, ":" + je + "$1")]
                }), be(r, {
                  props: [O(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, En = [yn], bn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var I = b.getAttribute("data-emotion");
      I.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || En;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var I = b.getAttribute("data-emotion").split(" "), _ = 1; _ < I.length; _++)
        i[I[_]] = !0;
      l.push(b);
    }
  );
  var d, h = [fn, ln];
  process.env.NODE_ENV !== "production" && h.push(vn({
    get compat() {
      return R.compat;
    }
  }), mn);
  {
    var p, y = [tn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? p.insert(b.return) : b.value && b.type !== fr && p.insert(b.value + "{}"));
    } : an(function(b) {
      p.insert(b);
    })], C = nn(h.concat(o, y)), S = function(I) {
      return se(en(I), C);
    };
    d = function(I, _, E, $) {
      p = E, process.env.NODE_ENV !== "production" && _.map !== void 0 && (p = {
        insert: function(c) {
          E.insert(c + _.map);
        }
      }), S(I ? I + "{" + _.styles + "}" : _.styles), $ && (R.inserted[_.name] = !0);
    };
  }
  var R = {
    key: n,
    sheet: new Lt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: d
  };
  return R.sheet.hydrate(l), R;
}, ir = { exports: {} }, P = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function gn() {
  if (Fr)
    return P;
  Fr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, R = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function $(c) {
    if (typeof c == "object" && c !== null) {
      var j = c.$$typeof;
      switch (j) {
        case r:
          switch (c = c.type, c) {
            case d:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case p:
                case R:
                case S:
                case f:
                  return c;
                default:
                  return j;
              }
          }
        case n:
          return j;
      }
    }
  }
  function D(c) {
    return $(c) === h;
  }
  return P.AsyncMode = d, P.ConcurrentMode = h, P.ContextConsumer = l, P.ContextProvider = f, P.Element = r, P.ForwardRef = p, P.Fragment = a, P.Lazy = R, P.Memo = S, P.Portal = n, P.Profiler = i, P.StrictMode = o, P.Suspense = y, P.isAsyncMode = function(c) {
    return D(c) || $(c) === d;
  }, P.isConcurrentMode = D, P.isContextConsumer = function(c) {
    return $(c) === l;
  }, P.isContextProvider = function(c) {
    return $(c) === f;
  }, P.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, P.isForwardRef = function(c) {
    return $(c) === p;
  }, P.isFragment = function(c) {
    return $(c) === a;
  }, P.isLazy = function(c) {
    return $(c) === R;
  }, P.isMemo = function(c) {
    return $(c) === S;
  }, P.isPortal = function(c) {
    return $(c) === n;
  }, P.isProfiler = function(c) {
    return $(c) === i;
  }, P.isStrictMode = function(c) {
    return $(c) === o;
  }, P.isSuspense = function(c) {
    return $(c) === y;
  }, P.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === C || typeof c == "object" && c !== null && (c.$$typeof === R || c.$$typeof === S || c.$$typeof === f || c.$$typeof === l || c.$$typeof === p || c.$$typeof === I || c.$$typeof === _ || c.$$typeof === E || c.$$typeof === b);
  }, P.typeOf = $, P;
}
var N = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function _n() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, R = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function $(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === C || typeof v == "object" && v !== null && (v.$$typeof === R || v.$$typeof === S || v.$$typeof === f || v.$$typeof === l || v.$$typeof === p || v.$$typeof === I || v.$$typeof === _ || v.$$typeof === E || v.$$typeof === b);
    }
    function D(v) {
      if (typeof v == "object" && v !== null) {
        var he = v.$$typeof;
        switch (he) {
          case r:
            var ne = v.type;
            switch (ne) {
              case d:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ne;
              default:
                var ee = ne && ne.$$typeof;
                switch (ee) {
                  case l:
                  case p:
                  case R:
                  case S:
                  case f:
                    return ee;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var c = d, j = h, A = l, Be = f, Re = r, qe = p, Ge = a, xe = R, q = S, K = n, Q = i, Te = o, Oe = y, fe = !1;
    function Pe(v) {
      return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(v) || D(v) === d;
    }
    function le(v) {
      return D(v) === h;
    }
    function Ne(v) {
      return D(v) === l;
    }
    function Ae(v) {
      return D(v) === f;
    }
    function $e(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function He(v) {
      return D(v) === p;
    }
    function Je(v) {
      return D(v) === a;
    }
    function de(v) {
      return D(v) === R;
    }
    function pe(v) {
      return D(v) === S;
    }
    function re(v) {
      return D(v) === n;
    }
    function ve(v) {
      return D(v) === i;
    }
    function te(v) {
      return D(v) === o;
    }
    function Ke(v) {
      return D(v) === y;
    }
    N.AsyncMode = c, N.ConcurrentMode = j, N.ContextConsumer = A, N.ContextProvider = Be, N.Element = Re, N.ForwardRef = qe, N.Fragment = Ge, N.Lazy = xe, N.Memo = q, N.Portal = K, N.Profiler = Q, N.StrictMode = Te, N.Suspense = Oe, N.isAsyncMode = Pe, N.isConcurrentMode = le, N.isContextConsumer = Ne, N.isContextProvider = Ae, N.isElement = $e, N.isForwardRef = He, N.isFragment = Je, N.isLazy = de, N.isMemo = pe, N.isPortal = re, N.isProfiler = ve, N.isStrictMode = te, N.isSuspense = Ke, N.isValidElementType = $, N.typeOf = D;
  }()), N;
}
process.env.NODE_ENV === "production" ? ir.exports = gn() : ir.exports = _n();
var Sn = ir.exports, nt = Sn, wn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Cn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, at = {};
at[nt.ForwardRef] = wn;
at[nt.Memo] = Cn;
var Rn = !0;
function xn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var ot = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Rn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Tn = function(r, n, a) {
  ot(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function On(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Pn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, jr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Nn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", An = /[A-Z]|^ms/g, it = /_EMO_([^_]+?)_([^]*?)_EMO_/g, vr = function(r) {
  return r.charCodeAt(1) === 45;
}, Lr = function(r) {
  return r != null && typeof r != "boolean";
}, tr = /* @__PURE__ */ on(function(e) {
  return vr(e) ? e : e.replace(An, "-$&").toLowerCase();
}), Le = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(it, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return Pn[r] !== 1 && !vr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var $n = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, kn = ["normal", "none", "initial", "inherit", "unset"], In = Le, Dn = /^-ms-/, Mn = /-(.)/g, Yr = {};
  Le = function(r, n) {
    if (r === "content" && (typeof n != "string" || kn.indexOf(n) === -1 && !$n.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = In(r, n);
    return a !== "" && !vr(r) && r.indexOf("-") !== -1 && Yr[r] === void 0 && (Yr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Dn, "ms-").replace(Mn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var st = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function we(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(st);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Fn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, f = n(e);
        return G = i, we(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], d = n.replace(it, function(p, y, C) {
          var S = "animation" + l.length;
          return l.push("const " + S + " = keyframes`" + C.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + S + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + d + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + d + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Fn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += we(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Lr(f) && (a += tr(i) + ":" + Le(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(st);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Lr(f[l]) && (a += tr(i) + ":" + Le(i, f[l]) + ";");
        else {
          var d = we(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += tr(i) + ":" + d + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Nn), a += i + "{" + d + "}";
          }
        }
      }
    }
  return a;
}
var Wr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ct;
process.env.NODE_ENV !== "production" && (ct = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, zr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += we(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(jr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += we(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(jr), i += f[l]);
  var d;
  process.env.NODE_ENV !== "production" && (i = i.replace(ct, function(C) {
    return d = C, "";
  })), Wr.lastIndex = 0;
  for (var h = "", p; (p = Wr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    p[1];
  var y = On(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: d,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, Vn = function(r) {
  return r();
}, jn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Ln = jn || Vn, hr = {}.hasOwnProperty, mr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ bn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (mr.displayName = "EmotionCacheContext");
mr.Provider;
var Yn = function(r) {
  return /* @__PURE__ */ ur(function(n, a) {
    var o = qr(mr);
    return r(n, o, a);
  });
}, ut = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (ut.displayName = "EmotionThemeContext");
var Ur = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Wn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Ur(n[1]);
}, zn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Un = function(r) {
  return r.replace(/\$/g, "-");
}, Bn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Wn(n[a]);
      if (o) {
        if (zn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Un(o);
      }
    }
}, sr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", cr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", qn = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    hr.call(n, o) && (a[o] = n[o]);
  if (a[sr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Bn(new Error().stack);
    i && (a[cr] = i);
  }
  return a;
}, Gn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return ot(n, a, o), Ln(function() {
    return Tn(n, a, o);
  }), null;
}, ft = /* @__PURE__ */ Yn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[sr], i = [a], f = "";
  typeof e.className == "string" ? f = xn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = zr(i, void 0, X.useContext(ut));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var d = e[cr];
    d && (l = zr([l, "label:" + d + ";"]));
  }
  f += r.key + "-" + l.name;
  var h = {};
  for (var p in e)
    hr.call(e, p) && p !== "css" && p !== sr && (process.env.NODE_ENV === "production" || p !== cr) && (h[p] = e[p]);
  return h.ref = n, h.className = f, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Gn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ft.displayName = "EmotionCssPropInternal");
var Hn = ft;
function Ye(e, r, n) {
  return hr.call(r, "css") ? $r.jsx(Hn, qn(e, r), n) : $r.jsx(e, r, n);
}
const Jn = (e) => {
  const { onFocus: r, onBlur: n, children: a, colorScheme: o = "white", dropList: i, disabled: f, position: l = "bottom-start", triggerProps: d, trigger: h = "click", defaultPopupVisible: p, autoAlignPopupWidth: y, popupVisible: C, onVisibleChange: S, ...R } = e, [b, I] = It(!1, {
    defaultValue: p,
    value: C
  }), _ = (E) => {
    C === void 0 && I(E), S == null || S(E);
  };
  return Ye(kt, { onFocus: r, onBlur: n, trigger: h, colorScheme: o, autoAlignPopupWidth: y, withoutPadding: !0, clickOutsideToClose: !0, closeOnInnerClick: !0, position: l, showArrow: !1, alignPoint: h === "contextmenu", popupVisible: b, content: i, onVisibleChange: (E) => {
    _(E);
  }, disabled: f, ...d, ...R, children: a });
};
Jn.displayName = "Dropdown";
function Kn() {
  return ge`
    position: relative;
    border-radius: 8px;
    overflow: auto;
    background-color: ${Gr(`--${Hr}-white-01`)};
    padding: 8px 0;
  `;
}
function Zn(e, r, n, a, o) {
  const i = ge`
    color: ${o ? ie("red", "01") : ie("grayBlue", "02")};

    &:hover {
      cursor: pointer;
      background-color: ${o ? ie("red", "07") : ie(r, "09")};
    }
  `, f = ge`
    cursor: not-allowed;
    color: ${Gr(`--${Hr}-grayBlue-05`)};
  `, l = ge`
    color: ${ie(e, "01")};
    background: ${ie(e, "07")};
  `;
  let d;
  return a ? d = l : n ? d = f : d = i, ge`
    font-size: 14px;
    line-height: 32px;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    padding: 0 16px;
    ${d};
  `;
}
const lt = $t({}), Xn = ur((e, r) => {
  const { children: n, onClickItem: a, hoverColorScheme: o = "grayBlue", ...i } = e;
  return Ye("div", { ref: r, css: [Kn(), Dt(e)], ...Jr(i), children: Ye(lt.Provider, { value: {
    onClickItem: a,
    hoverColorScheme: o
  }, children: n }) });
});
Xn.displayName = "DropList";
const Qn = ur((e, r) => {
  const { title: n, children: a, disabled: o, onClick: i, colorScheme: f = "blue", hoverColorScheme: l, deleted: d, selected: h, value: p, isSelectOption: y = !0, ...C } = e, { onClickItem: S, hoverColorScheme: R = "grayBlue" } = qr(lt);
  return Ye("div", { ref: r, css: Zn(f, l ?? R, o, h, d), onClick: (I) => {
    o || (i == null || i(I), y && (S == null || S(p, n || a, I)));
  }, ...Jr(C), children: n || a });
});
Qn.displayName = "DropListItem";
export {
  Xn as DropList,
  lt as DropListContext,
  Qn as DropListItem,
  Jn as Dropdown
};
//# sourceMappingURL=index.js.map
